<script lang="ts">
</script>

<main>
  <footer>
    <div>With content from The Perilous Wilds by Jason Lutes</div>
    <div>Distributed under the Creative Commons Attribution-ShareAlike 3.0 Unported license</div>
    <div>Rolling dice sounds from SoundBible under Creative Commons Attribution</div>
    <div>Find the source for this project on <a href="https://github.com/RussellChamp/tpw-roller">Github</a></div>
  </footer>
</main>

<style>
</style>
